import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2028dac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-controls"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"display":"flex","gap":"5px","align-items":"center"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "search-box"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "table-loading"
}
const _hoisted_9 = {
  key: 3,
  class: "table-footer"
}
const _hoisted_10 = { class: "table-pagination" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-down" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "per-page-selector-menu"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-left" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-container", { stickyFooter: _ctx.stickyFooter, stickyHeader: _ctx.stickyHeader }])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("table", {
          key: 1,
          ref: "table",
          class: _normalizeClass(["table-data", { dense: _ctx.dense, highlightable: _ctx.highlightable }])
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", {
              style: _normalizeStyle(
						_ctx.options != null && _ctx.options.thead != null && _ctx.options.thead.background != null
							? `background:${_ctx.options.thead.background}`
							: ``
					)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.columns, (thead, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  onClick: ($event: any) => (_ctx.checkIsSortable(thead) ? _ctx.sortBy(thead) : null),
                  style: _normalizeStyle(_ctx.getStyleFromOptions(thead)),
                  key: i
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    (_ctx.isVisible('h-' + thead))
                      ? _renderSlot(_ctx.$slots, 'h-' + thead, {
                          key: 0,
                          row: thead,
                          value: thead
                        }, undefined, true)
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatHeader(thead)), 1)),
                    (_ctx.sortName == thead)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 2,
                          class: _normalizeClass(["fa", { 'fa-arrow-down': _ctx.sort > 0, 'fa-arrow-up': _ctx.sort < 0 }])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (_ctx.searchingColumn == thead)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 3,
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.searchingColumn = ''), ["stop"])),
                          class: "fa fa-times search-btn"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.searchingColumn == thead)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_imdex_text_field, {
                          ref_for: true,
                          ref: `${thead}-search`,
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                          value: _ctx.searchTerm,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
                          compact: "",
                          mini: "",
                          leadingIcon: "fal fa-search"
                        }, null, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ], 12, _hoisted_3))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredData, (tr, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.columns, (td, t) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: t,
                    style: _normalizeStyle(_ctx.getRowStyleFromOptions())
                  }, [
                    (_ctx.isVisible(td))
                      ? _renderSlot(_ctx.$slots, td, {
                          key: 0,
                          row: tr,
                          value: 
								_ctx.options?.columns?.[td]?.formatFn
									? _ctx.options.columns[td].formatFn(tr[td])
									: tr[td]
							
                        }, undefined, true)
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.options?.columns?.[td]?.formatFn
								? _ctx.options.columns[td].formatFn(tr[td])
								: tr[td]), 1))
                  ], 4))
                }), 128))
              ]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_imdex_spinner, {
            width: "40",
            size: "3",
            indeterminite: "",
            color: "#808080"
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "per-page",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.perPageSelector = !_ctx.perPageSelector), ["stop"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.perPage) + " " + _toDisplayString(_ctx.$t("table.perPage")) + " ", 1),
              _hoisted_11,
              (_ctx.perPageSelector)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ((_ctx.perPage = 10), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, " 10 " + _toDisplayString(_ctx.$t("table.perPage")), 1),
                    _createElementVNode("div", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ((_ctx.perPage = 20), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, " 20 " + _toDisplayString(_ctx.$t("table.perPage")), 1),
                    _createElementVNode("div", {
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ((_ctx.perPage = 50), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, " 50 " + _toDisplayString(_ctx.$t("table.perPage")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.perPage * (_ctx.page - 1) + 1) + " - " + _toDisplayString(_ctx.tableData.tableData.length >= _ctx.perPage * _ctx.page
							? _ctx.perPage * _ctx.page
							: _ctx.tableData.tableData.length) + " " + _toDisplayString(_ctx.$t("table.of")) + " " + _toDisplayString(_ctx.tableData.tableData.length), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_imdex_btn, {
                onClick: _ctx.prevPage,
                disabled: _ctx.page == 1,
                text: "",
                compact: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_imdex_btn, {
                onClick: _ctx.nextPage,
                text: "",
                disabled: !_ctx.hasNextPage,
                compact: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}